import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from '../../utils/api';

export const useGetStudentDocumentsQuery = (applicantId: string | number) => {
  const fetchStudentDocuments = async (): Promise<StudentDocumentResponse> => {
    return (await api.get(`/AdmissionDocument/Admin/GetStudentDocuments?applicantId=${applicantId}`))?.data;
  };

  const { data, isLoading, isError, error, refetch } = useQuery<StudentDocumentResponse, AxiosError<ApiErrorResponse>>({
    queryKey: ['get-student-documents', applicantId],
    queryFn: fetchStudentDocuments,
    enabled: Boolean(applicantId),
  });

  const errorMessage = error?.response?.data?.message || error?.message || 'Failed to fetch student documents';

  return {
    studentDocumentsData: data?.data ?? [],
    isStudentDocumentsLoading: isLoading,
    isStudentDocumentsError: isError,
    studentDocumentsErrorMessage: errorMessage,
    refetch,
  };
};